__turbopack_context__.v({
  "jumpMusic": "index-module-scss-module__Kv2B8G__jumpMusic",
});
